<template>
  <el-card v-loading="tableLoading">
      <!-- /* ---------------------------------- 搜索表单 ---------------------------------- */ -->
      <el-row>
          <el-form :model="form" v-bind="formProps.form" :rules="{}">
              <el-form-item prop="merchantNo" :label="$t('merchantBalance.label.merchantNo')">
                  <el-input v-model="form.merchantNo"></el-input>
              </el-form-item>

              <el-form-item>
                  <el-button @click="handleSearch()" size="mini" type="primary">
                      {{ $t('btns.search') }}
                  </el-button>
                  <el-button v-if="tableList.length && permission.indexOf('export:walletAmount') > -1"
                      @click="handleExport" size="mini" type="primary">
                      {{ $t('btns.export') }}
                  </el-button>
              </el-form-item>
              <el-form-item :label="`${$t('merchantBalance.label.allMerchantBalance')}:`">
                {{allMerchantBalance|toThousands}}
              </el-form-item>
          </el-form>
      </el-row>

      <el-row>
          <el-table :data="tableData" highlight-current-row @sort-change="sortChange"
              :default-sort="{ prop: 'allBalance', order: 'descending' }" :cell-style="{ textAlign: 'center' }"
              :header-cell-style="{ textAlign: 'center' }" style="width: 100%" overflow-x="auto">
              <el-table-column width="150px" prop="merchantNo" :label="$t('merchantBalance.label.merchantNo')">
              </el-table-column>
              <el-table-column width="150px" prop="merchantName" :label="$t('clientmanage.table.merchantName')" />
              <el-table-column width="130px" :label="$t('merchantIp.label.action')">
                  <template slot-scope="{ row }">
                      <el-button type="primary" size="mini" @click="handleDecetion(row)">{{
                          $t('merchantdetails.label.kou')
                          }}</el-button>
                  </template>
              </el-table-column>
              <el-table-column width="130px" :label="$t('merchantIp.label.action')">
                  <template slot-scope="{ row }">
                      <el-button type="primary" size="mini" @click="handleRecharge(row)">{{
                          $t('merchantdetails.label.recharge')
                          }}</el-button>
                  </template>
              </el-table-column>
              <el-table-column width="130px" :label="$t('merchantIp.label.action')">
                  <template slot-scope="{ row }">
                      <el-popconfirm :ref="`popover-${row.id}`" :key="`${row.id}`" :title="$t('orders.tip.danger')"
                          @confirm="transferAmount(row)">
                          <el-button :id="`transfer-${row.merchantNo}`" slot="reference" type="primary" size="mini">{{
                              $t('btns.transferAmount') }}</el-button>
                      </el-popconfirm>
                  </template>
              </el-table-column>
              <el-table-column width="120px" v-for="[key, val] of Object.entries(tableTypes)" :key="key" :prop="val"
                  :sortable="key === 'all'" :label="$t(`merchantdetails.label.${key}`)">
                  <template slot-scope="{ row }">
                      {{ row[val] | toThousands }}
                  </template>
              </el-table-column>
          </el-table>
      </el-row>

      <el-dialog :visible.sync="dialogFormVisible">
          <el-form ref="deceForm" :rules="deceFormRules" :model="deceForm">
              <el-form-item prop="amount" :label="$t('channelTest.label.amount')">
                  <el-input size="mini" v-model="deceForm.amount"> </el-input>
              </el-form-item>
              <el-form-item prop="remark" :label="$t('transaction.label.remark')">
                  <el-input size="mini" v-model="deceForm.remark"> </el-input>
              </el-form-item>
              <el-form-item prop="password" :label="$t('accountmanager.userPass')">
                  <el-input type="password" size="mini" v-model.trim="deceForm.password"> </el-input>
              </el-form-item>
              <el-form-item prop="walletType" :label="$t('merchantBalance.label.walletType')">
                <el-select size="mini" v-model="deceForm.walletType">
                    <el-option v-for="type in wallettypeList" :key="type" :value="type"></el-option>
                    <!-- <el-option :label="$t('btns.emptyValue')" value=""></el-option> -->
                </el-select>
            </el-form-item>
              <el-form-item>
                  <el-button @click="handleReqDece">
                      {{ $t('merchantdetails.label.kou') }}
                  </el-button>
              </el-form-item>
          </el-form>
      </el-dialog>

      <el-dialog :visible.sync="dialogFormVisible1">
          <el-form ref="rechargeForm" :rules="rechargeFormRules" :model="rechargeForm">
              <el-form-item prop="amount" :label="$t('channelTest.label.amount')">
                  <el-input size="mini" v-model="rechargeForm.amount"> </el-input>
              </el-form-item>
              <el-form-item prop="remark" :label="$t('transaction.label.remark')">
                  <el-input size="mini" v-model="rechargeForm.remark"> </el-input>
              </el-form-item>
              <el-form-item prop="password" :label="$t('accountmanager.userPass')">
                  <el-input type="password" size="mini" v-model.trim="rechargeForm.password"> </el-input>
              </el-form-item>
              <el-form-item prop="walletType" :label="$t('merchantBalance.label.walletType')">
                  <el-select size="mini" v-model="rechargeForm.walletType">
                      <el-option v-for="type in wallettypeList" :key="type" :value="type"></el-option>
                      <!-- <el-option :label="$t('btns.emptyValue')" value=""></el-option> -->
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button @click="handleReqRecharge">
                      {{ $t('merchantdetails.label.recharge') }}
                  </el-button>
              </el-form-item>
          </el-form>
      </el-dialog>
  </el-card>
</template>

<script>
  import walletAmountApi from '@/api/walletAmount';
  import merchantApi from '@/api/merchant';
  import ordersApi from '@/api/orders';
  import debounce from 'lodash/debounce';
  import { mapGetters } from 'vuex';
  export default {
      name: 'merchantBalance',
      data() {
          return {
              tableLoading: false,
              allMerchantBalance:'',
              formProps: {},
              agents: [],
              wallettypes: {
                  all: 'all',
                  bank_online: 'bank_online',
                  bank_qr: 'bank_qr',
                  bank_transfer: 'bank_transfer',
                  card_pc: 'card_pc',
                  card_zing: 'card_zing',
                  momo_fix_qr: 'momo_fix_qr',
                  momo_qr: 'momo_qr',
                  viettel_fix_qr: 'viettel_fix_qr',
                  viettel_qr: 'viettel_qr',
                  zalo_qr: 'zalo_qr'
              },
              tableTypes: {
                  all: 'allBalance',
                  usdt_qr: 'usdtBalance',
                //   momoBalance: 'momoBalance',
                //   zaloBalance: 'zaloBalance',
                //   qrProBalance: 'qrProBalance',
                //   bank_transfer: 'bankTransferBalance',
                  // bank_online: 'bankOnlineBalance',
                //   bank_qr: 'bankQrBalance',
                //   card_pc: 'cardPcBalance',
                  // payoutBalance: 'payoutBalance',
                //   viettelBalance: 'viettelBalance',
                //   viettelFixBalance: 'viettelFixBalance',
                  // zaloTransferBalance: 'zaloTransferBalance',
              },
              tableData: [],
              form: {
                  merchantNo: ''
              },
              /* ---------------------------------- 人工扣款 ---------------------------------- */
              dialogFormVisible: false,
              deceData: {},
              deceForm: {
                  amount: null,
                  remark: '',
                  password: '',
                  walletType: ''
              },
              dialogFormVisible1: false,
              rechargeData: {},
              rechargeForm: {
                  amount: null,
                  remark: '',
                  password: '',
                  walletType: ''
              },

              pagination: {
                  no: 1,
                  size: 10000000
              }
          };
      },
      computed: {
          ...mapGetters(['permission']),
          tableList: {
              get() {
                  const arr = this.tableData.list || [{}];
                  const obj = arr.reduce((acc, curr) => {
                      if (acc[curr.merchantNo]) {
                          acc[curr.merchantNo][curr.walletType] = curr.walletAmount;
                          acc[curr.merchantNo]['merchantNo'] = curr.merchantNo;
                      } else {
                          acc[curr.merchantNo] = {
                              [curr.walletType]: curr.walletAmount,
                              merchantNo: curr.merchantNo
                          };
                      }
                      return acc;
                  }, {});
                  return Object.keys(obj).map((r) => obj[r]);
              },
              set(value) {
                  console.log('传进来的数值是。。。', value);
              }
          },

          deceFormRules() {
              return {
                  amount: [
                      {
                          required: true,
                          message: this.$t('merchantdetails.rules.amount.required')
                      }
                  ],
                  remark: [
                      {
                          required: true,
                          message: this.$t('merchantdetails.rules.remark.required')
                      }
                  ],
                  password: [
                      {
                          required: true,
                          message: this.$t('login.rules.password')
                      }
                  ],
                  walletType: [
                      {
                          required: true,
                          message: this.$t('merchantBalance.rules.walletType')
                      }
                  ]
              };
          },

          rechargeFormRules() {
              return {
                  amount: [
                      {
                          required: true,
                          message: this.$t('merchantdetails.rules.amount.required')
                      }
                  ],
                  remark: [
                      {
                          required: true,
                          message: this.$t('merchantdetails.rules.remark.required')
                      }
                  ],
                  password: [
                      {
                          required: true,
                          message: this.$t('login.rules.password')
                      }
                  ],
                  walletType: [
                      {
                          required: true,
                          message: this.$t('merchantBalance.rules.walletType')
                      }
                  ]
              };
          },
          wallettypeList() {
              return ['all','usdt_qr'];
            //   return Object.keys(this.wallettypes).filter((item)=>item=='all'||item=='usdt_qr');
          }
      },
      created() {
          this.init();
      },
      mounted() {
          this.getTableList();
          this.getAgents();
          this.wallettype();
      },
      methods: {
          init() {
              this.handleSearch = debounce(this.getTableList, 300);

              this.handleEmpty();

              this.formProps = {
                  form: {
                      ref: 'form',
                      'label-width': 'auto',
                      inline: true,
                      size: 'small',
                      rules: {}
                  }
              };
          },
          sortChange(column) {
              console.log(column, '   sort change');

              this.tableList.sort((pre, next) => pre[column.prop] - next[column.prop] > 0);
              console.log('这里的数据排序了吗。。。AAAAAAAAAAAAAAAAAA', this.tableList);

              // this.tableList = this.tableList.sort(this.sortFun(column.prop, column.order === 'ascending'));
          },
          sortFun(attr, rev) {
              this.sortArrayFun(attr, rev);
          },
          sortArrayFun(attr, rev) {
              if (rev == undefined) {
                  rev = 1;
              } else {
                  rev = rev ? 1 : -1;
              }
              return function (a, b) {
                  a = a[attr];
                  b = b[attr];
                  console.log('怎么这么复杂。。。', a, b);
                  if (a < b) {
                      return rev * -1;
                  }
                  if (a > b) {
                      return rev * 1;
                  }
                  return 0;
              };
          },
          handleDecetion(row) {
              this.dialogFormVisible = true;
              this.deceData = row;
          },
          handleRecharge(row) {
              this.dialogFormVisible1 = true;
              this.rechargeData = row;
          },
          async transferAmount(row) {
              if (!row.merchantNo) return;
              let times = 0;
              let currentBtn = document.getElementById(`transfer-${row.merchantNo}`);
              let { data } = await merchantApi.doTransfer({ merchantNo: row.merchantNo });
              if (data && data.code == 200) {
                  let itv = setInterval(() => {
                      if (times == 60) {
                          currentBtn.removeAttribute('disabled');
                          clearInterval(itv);
                      } else {
                          if (!currentBtn.getAttribute('disabled')) {
                              currentBtn.setAttribute('disabled', 'disabled');
                          }
                          times++;
                      }
                  }, 1000);
                  this.$message.success(this.$t('status.success'));
                  this.getTableList();
              } else {
                  this.$message.error(data.msg || 'Network error!');
              }
          },
          handleReqDece() {
              this.$refs.deceForm.validate(async (valid) => {
                  if (valid) {
                      const params = {
                          ...this.deceForm,
                          merchantNo: this.deceData.merchantNo
                      };
                      const res = await merchantApi.doDeduction(params);

                      if (res && res.data) {
                          if (res.data.code == 200) {
                              this.dialogFormVisible = false;
                              this.getTableList();
                          } else {
                              this.$message.warning(res.msg);
                          }
                      }
                  }
              });
          },
          handleReqRecharge() {
              this.$refs.rechargeForm.validate(async (valid) => {
                  if (valid) {
                      const params = {
                          ...this.rechargeForm,
                          merchantNo: this.rechargeData.merchantNo
                      };
                      const res = await merchantApi.doRecharge(params);

                      if (res && res.data) {
                          if (res.data.code == 200) {
                              this.dialogFormVisible1 = false;
                              this.getTableList();
                          } else {
                              this.$message.warning(res.msg);
                          }
                      }
                  }
              });
          },

          handleEmpty() {
              this.form = {
                  merchantNo: ''
              };
          },

          /* ---------------------------------- 格式化数据 --------------------------------- */
          formatParams() {
              return {
                  ...Object.keys(this.form).reduce((acc, key) => {
                      if (this.form[key] === 0 || this.form[key]) {
                          acc[key] = this.form[key];
                      }
                      return acc;
                  }, {})
              };
          },
          async getAgents() {
              const { data } = await ordersApi.getMerchantData({
                  data: {
                      merchantType: 1
                  }
              });
              if (data && data.code === 200) {
                  this.agents = data.data;
              } else {
                  this.$message.error(this.$t('status.error'));
              }
          },
          // 钱包类型
          async wallettype() {
              const { data } = await merchantApi.getType();
              if (data) {
                  if (data.code === 200) {
                      this.wallettypes = data.data;
                  } else {
                      this.$message.error(data.msg);
                  }
              }
          },
          async handleExport() {
              const { data } = await walletAmountApi.doExport(this.formatParams());
              if (data) {
                  const BLOB = data;
                  const fileReader = new FileReader();
                  fileReader.readAsDataURL(BLOB);
                  fileReader.onload = (event) => {
                      // 处理load事件。该事件在读取操作完成时触发
                      // 新建个下载的a标签，完成后移除。
                      let a = document.createElement('a');
                      a.download = `Merchant-Balance-${Number(new Date())}.xlsx`;
                      a.href = event.target.result;
                      document.body.appendChild(a);
                      a.click();
                      document.body.removeChild(a);
                      this.$message.success(this.$t('status.success'));
                  };
              } else {
                  this.$message(this.$t('status.error'));
              }
          },
          async getTableList() {
            this.tableLoading = true;
              const { data } = await walletAmountApi.getPage({
                  data: this.formatParams(),
                  // params: this.pagination
              });
              if (data) {
                  if (data.code === 200) {
                      this.tableData = data.data.list;
                      this.allMerchantBalance =  data.data.summary.allMerchantBalance
                      this.tableLoading = false;
                  } else {
                      this.$message.error(data.msg);
                      this.tableLoading = false;
                  }
              } else {
                this.tableLoading = false;
              }
          }
      }
  };
</script>

<style lang="scss" scoped>
  /deep/ .el-button[disabled='disabled'] {
      color: #fff;
      background-color: #a0cfff;
      border-color: #a0cfff;
      cursor: no-drop;
  }
</style>


// WEBPACK FOOTER //
// src/components/merchant-balance/index.vue